import * as React from 'react';
import Cached from 'material-ui/svg-icons/action/cached';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';

import { BicyclesForm } from '@modules/bicycles/BicyclesForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const bicyclesUrl = '/metropolis/api/bi/bicycles';
export const bicyclesLabel = 'Kola';
export const bicyclesPath = '/bicycles';
export const bicyclesGridName = 'module-bicycles';

export const BicyclesGrid = compose<any, any>(
  withRouter,
  setDisplayName('BicyclesGrid'),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: bicyclesLabel }]),
  withColumns(Agenda.BICYCLES),
  withProps(({ columns }) => ({
    name: bicyclesGridName,
    url: bicyclesUrl,
    Form: BicyclesForm,
    dialog: false,
    gridProps: {
      columns,
      deleteFiltersTooltip: 'Reset filtrů',
      deleteFiltersIcon: <Cached />,
      ActionBar: () => <ColumnManager agenda={Agenda.BICYCLES} />,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: false,
      locale: 'cz',
      adding: true,
      pageSize: 50,
      version: 11
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/bicycles/BicyclesGrid.tsx